import axiosInstance from "../Utils/axiosConfig";

const GetCryptoPrice = async (data) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_API_REST_URL}/api/get_crypto_price`,
    data,
    {
      headers: {
        Authorization: "Bearer " + localStorage?.getItem("token"),
      },
    }
  );
  return response?.data;
};

const walletService = {
  GetCryptoPrice,
};

export default walletService;
